import { render, staticRenderFns } from "./supplier_list.vue?vue&type=template&id=b98b31f0&scoped=true"
import script from "./supplier_list.vue?vue&type=script&lang=js"
export * from "./supplier_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98b31f0",
  null
  
)

export default component.exports